import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const Spinner = function(props) {
  const { children, className, enabled } = props;

  let element = null;

  if (enabled) {
    element = (
      <div className={ classNames(className, 'spinner-container') }>
        <i className='fa fa-spin fa-spinner' />
      </div>
    );
  } else if (children) {
    element = (<div className={ className }>{ children }</div>);
  }

  return element;
};

Spinner.propTypes = {
  enabled: PropTypes.bool
};

export default Spinner;



// WEBPACK FOOTER //
// ./app/components/shared/_Spinner.jsx